import { BillingContactModel } from '../billing-contact.model';
import { CurrencyType } from '@fi-app/customer-billing/customer-billing-price/currency-type';
import { Injector } from '@angular/core';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { ContactModel } from '@fi-app/components/contact.model';
import { isDate } from 'util';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiAppSettings } from '@fi-shared/fi-app-settings';

export class BusinessUnitCreditCardInformationModel {
    Id = 0;
    CreditCardNumber = '';
    CVCCode = '';
    ReceiverName = '';
    ReceiverEmail = '';
    BusinessUnitId = 0;
    InvoiceLanguageType = FiApplicationLanguageType.Swedish;
    PaymentCurrencyType = CurrencyType.SEK;
    PaymentType = '';
    ValidationDate: any;
    ValidationDateLabel: string;
    private contentLanguagesService: ContentLanguagesService;
    private customerDataService: FiCustomerDataService;
    Contacts: BillingContactModel[];

    constructor(data, injector: Injector) {
        this.contentLanguagesService = injector.get(ContentLanguagesService);
        this.customerDataService = injector.get(FiCustomerDataService);

        this.intPropertiesWithObjects(this);

        if (data) this.Initialize(data);
    }

    Initialize(data) {
        Object.assign(this, data);

        this.intPropertiesWithObjects(this);

        if (data.VaildationDate) {
            this.ValidationDate = data.VaildationDate;
        }

        // check date exists and not a min value
        if (!isDate(this.ValidationDate)) {
            this.ValidationDate = new Date(this.ValidationDate);
        }

        if (this.ValidationDate.getFullYear() === 1) {
            this.ValidationDate = new Date();
            this.ValidationDate.setFullYear(new Date().getFullYear() + 1);
        }

        const months = this.contentLanguagesService.GetMonthShortNames();
        for (let i = 0; i < months.length; i++) {
            if (months[i].Id == this.ValidationDate.getMonth()) {
                this.ValidationDateLabel = months[i].Name + ' ' + this.ValidationDate.getFullYear();
                break;
            }
        }

        this.InvoiceLanguageType =
            data.InvoiceLanguageType || this.customerDataService.customerData.DefaultApplicationLanguageType;
        this.PaymentCurrencyType = data.PaymentCurrencyType || FiAppSettings.DefaultPaymentCurrency;

        if (data.Contacts && data.Contacts.length > 0) {
            this.Contacts = [];
            data.Contacts.forEach((contact) => {
                const contactModel = new BillingContactModel();
                contactModel.Initialize(contact);
                this.Contacts.push(contactModel);
            });
        }
        return this;
    }

    private intPropertiesWithObjects(data) {
        data.VaildationDate = new Date();
        data.VaildationDate.setFullYear(new Date().getFullYear() + 1);

        data.Contacts = [new BillingContactModel()];
        data.Contacts[0].IsDefault = true;
    }

    private readonly ignoredOnSerializationFields = ['contentLanguagesService', 'customerDataService'];
    toJSON() {
        let result: { [prop: string]: any } = {};
        for (let x in this) {
            if (this.ignoredOnSerializationFields.indexOf(x) === -1) result[x] = this[x];
        }

        return result;
    }
}
